<template>
  <div class="p-10">
    <h3 class="text-3xl font-semibold text-slate-900">All Organizations</h3>

    <div class="my-base flex items-center flex-wrap gap-4">
      <h3 class="text-xl font-semibold text-slate-900">Select privacy type</h3>
      <div class="flex items-center gap-4">
        <vs-radio
          v-for="(type, index) in orgPrivacyTypes"
          :key="index"
          class=""
          :name="type"
          :vs-value="type"
          v-model="privacyType"
        >
          <h4 class="text-lg capitalize font-semibold text-slate-900">
            {{ type }}
          </h4>
        </vs-radio>
      </div>
    </div>
    <div v-if="isLoading">
      <vs-row class="rounded-lg grid flex-col lg:grid-cols-3 grid-cols-1 gap-8">
        <vs-row
          v-for="i in 6"
          :key="i"
          style="min-height: 250px"
          class="p-24 rounded-lg bg-slate-200 animate-pulse"
        />
      </vs-row>
    </div>
    <div v-else>
      <div class="vx-row" v-if="orgs.length > 0">
        <div
          v-for="(myOrgs, index) in orgs"
          :key="'superOrg-' + index"
          class="vx-col w-full md:w-1/2 lg:w-1/3 mb-base"
        >
          <vx-card class="org-card overflow-hidden shadow-lg">
            <div
              class="flex flex-col gap-4 justify-between"
              style="min-height: 250px"
            >
              <div class="flex flex-col md:flex-row items-center gap-4">
                <vs-avatar
                  v-if="myOrgs.logo"
                  class="profile-picture"
                  size="100px"
                  :src="
                    constants.s3Bucket + '/organization/logo/' + myOrgs.logo
                  "
                />
                <vs-avatar
                  v-else
                  class="profile-picture"
                  size="100px"
                  :src="
                    require('@/assets/images/icons/organization/business_black_36dp.svg')
                  "
                />
                <div class="text-left md:w-1/2">
                  <h2 class="mb-1 text-3xl font-semibold">{{ myOrgs.name }}</h2>
                </div>
              </div>
              <div v-if="myOrgs.about">
                <p class="text-slate-500 text-md">{{ myOrgs.about }}</p>
              </div>
              <a
                v-if="myOrgs.website"
                :href="myOrgs.website"
                target="_blank"
                class="mb-8 flex items-center gap-2"
              >
                <vs-icon
                  size="small"
                  color="#4481EB"
                  icon="icon-globe"
                  icon-pack="feather"
                />

                <p class="text-slate-500">{{ myOrgs.website }}</p>
              </a>

              <div
                class="bg-grey-200 flex items-center justify-between w-full py-4 px-6 left-0 absolute bottom-0"
              >
                <span class="flex items-center gap-2">
                  <img
                    src="@/assets/images/icons/people.svg"
                    alt="Community size"
                  />

                  <p class="text-slate-500">
                    {{ myOrgs.communityMembersCount || 0 }}
                  </p>
                </span>

                <span class="flex items-center gap-2">
                  <img
                    src="@/assets/images/icons/wallet_credit_card.svg"
                    alt="Treasury"
                  />

                  <p class="text-slate-500">€{{ myOrgs.funds.amount.toFixed(2) || 0 }}</p>
                </span>
              </div>

              <div>
                <!-- <vs-button
                  v-if="!myOrgs.slug"
                  class="mb-base"
                  size="large"
                  color="primary"
                  type="filled"
                  @click.stop="manageOrganization(myOrgs._id)"
                  >Manage</vs-button
                >
                <vs-button
                  v-else
                  class="mb-base"
                  size="large"
                  color="primary"
                  type="filled"
                  @click.stop="manageOrganization(myOrgs.slug)"
                  >Manage</vs-button
                > -->
                <!-- <vs-row vs-type="flex" vs-justify="center">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="6"
                  >
                    <vs-button
                      color="#A9A9A9"
                      type="border"
                      style="border-radius: 6px"
                      >Copy Link</vs-button
                    >
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="6"
                  >
                    <vs-button
                      color="#A9A9A9"
                      type="border"
                      style="border-radius: 6px"
                      >Statistics</vs-button
                    >
                  </vs-col>
                </vs-row> -->
              </div>
            </div>
          </vx-card>
        </div>
      </div>
      <div
        v-else
        class="flex items-center justify-center text-4xl text-slate-900"
      >
        No organization found for privacy setting as
        <span class="capitalize"> "{{ privacyType }}""</span>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/constants.js";

export default {
  data() {
    return {
      constants,
      privacyType: "public",
      orgPrivacyTypes: ["public", "private", "test", "secret"],
      orgs: [],
      isLoading: true,
    };
  },
  computed: {
    authUserData() {
      return this.$store.state.auth.user;
    },
  },
  watch: {
    privacyType: {
      handler() {
        this.getOrganizationByPrivacy();
      },
      deep: true,
    },
  },
  mounted() {
    this.getOrganizationByPrivacy();
  },
  methods: {
    async getOrganizationByPrivacy() {
      try {
        if (!this.authUserData) {
          this.$router.push("/");
          return;
        }

        this.orgs = [];
        this.isLoading = true;
        const privacyType = this.privacyType.toUpperCase();
        const res = await this.$store.dispatch(
          "organization/fetchOrganizationsByPrivacyType",
          privacyType
        );

        if (res && res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            let org = res.data[i];
            let count = await this.getCommunityCount(org._id);
            let funds = await this.getOrganizationsFunds(org._id);
            org.communityMembersCount = count;
            org.funds = funds;
          }
          this.orgs = res.data;
        }
      } catch (err) {
        console.error(err);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },
    async getCommunityCount(orgId) {
      try {
        const res = await this.$store.dispatch(
          "organization/fetchOrganizationsMembersCount",
          orgId
        );
        return res && res.data && res.data.count ? res.data.count : 0;
      } catch (err) {
        console.error(err);
        return 0;
      }
    },
    async getOrganizationsFunds(orgId) {
      try {
        const res = await this.$store.dispatch(
          "organization/fetchOrganizationsFunds",
          orgId
        );
        return res && res.data ? res.data : {};
      } catch (err) {
        console.error(err);
        return 0;
      }
    },
  },
};
</script>

<style scoped>
.vx-card >>> .vs-con-loading__container{
  height: 100%;

}</style>
